import { render, staticRenderFns } from "./DonationSettings.vue?vue&type=template&id=518a7e7a&scoped=true"
import script from "./DonationSettings.vue?vue&type=script&lang=js"
export * from "./DonationSettings.vue?vue&type=script&lang=js"
import style0 from "./DonationSettings.vue?vue&type=style&index=0&id=518a7e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518a7e7a",
  null
  
)

export default component.exports